<template>
  <div style="width: 100%; height: 100%; overflow: scroll; overflow-x: unset">
    <a-row>
      <div class="div-content">
        <div
          v-show="component.note.style"
          :class="[
            'div-content-title',
            visible == 1 ? 'div-content-title-c' : '',
          ]"
          @click="change(1)"
        >
          基本设置
        </div>
        <div
          v-show="component.note.props"
          :class="[
            'div-content-title',
            visible == 2 ? 'div-content-title-c' : '',
          ]"
          @click="change(2)"
        >
          属性
        </div>
        <div
          v-show="component.note.events"
          :class="[
            'div-content-title',
            visible == 3 ? 'div-content-title-c' : '',
          ]"
          @click="change(3)"
        >
          事件
        </div>
        <div
          v-show="component.note.data"
          :class="[
            'div-content-title',
            visible == 4 ? 'div-content-title-c' : '',
          ]"
          @click="change(4)"
        >
          数据
        </div>
      </div>
      <div class="divideLine" />
    </a-row>

    <!-- 样式 -->
    <a-row
      v-show="component.note.style && visible == 1"
      style="margin-top: 10px"
    >
      <right-style :component="component" />
    </a-row>
    <!-- 属性 -->
    <a-row
      v-show="component.note.props && visible == 2"
      style="margin-top: 10px"
    >
      <right-attribute :component="component" />
    </a-row>
    <!-- 事件 -->
    <a-row
      v-show="component.note.events && visible == 3"
      style="margin-top: 10px"
    >
      <right-event :component="component" />
    </a-row>
    <!-- 数据 -->
    <a-row
      v-show="component.note.data && visible == 4"
      style="margin-top: 10px"
    >
      <right-data :component="component" />
    </a-row>
  </div>
</template>

<script>
import RightAttribute from "./right-attribute/index.vue";
import RightData from "./right-data/index.vue";
import RightEvent from "./right-event/index.vue";

import Page from "@/utils/Page";
import BlockComponent from "@/utils/BlockComponent";

import RightStyle from "./right-style/index.vue";
export default {
  components: {
    RightAttribute,
    RightData,
    RightEvent,
    RightStyle,
  },
  props: {
    component: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      visible: 1,
    };
  },
  methods: {
    change(value) {
      this.visible = value;
    },
  },
};
</script>
<style scoped>
@import "index.css";
</style>
